import { FarmDetailsContainer } from '@/features/farm-details/FarmDetailsContainer'

export function FarmDetails() {
  return <FarmDetailsContainer />
}
